export const AssigneePickerObjectTypes = {
    NotInProject: 'NotInProject',
    InProject: 'InProject',
    Team: 'Team',
    Company: 'Company',
    SameRole: 'SameRole'
};
export const AssigneePickerFilter = {
    All: 'ALL',
    NativePartnerUsersAndTeams: 'NATIVE_PARTNER_USERS_AND_TEAMS',
    ExternalUsers: 'EXTERNAL_USERS',
    ExternalAndClientPartnerUsers: 'EXTERNAL_AND_CLIENT_PARTNER_USERS',
    InProjectUsersAndTeams: 'IN_PROJECT_USERS_AND_TEAMS',
    NotInProjectUsersAndTeams: 'NOT_IN_PROJECT_USERS_AND_TEAMS',
    InProjectUsers: 'IN_PROJECT_USERS',
    NotInProjectUsers: 'NOT_IN_PROJECT_USERS',
    NativeUsersAndTeams: 'NATIVE_USERS_AND_TEAMS',
    NativeUsers: 'NATIVE_USERS',
    Teams: 'TEAMS',
    UnResolvedPlaceholders: 'UNRESOLVED_PLACEHOLDERS',
    PlaceholderResolutions: 'PLACEHOLDER_RESOLUTIONS',
    CompanyUsers: 'COMPANY_USERS',
    UserFields: 'USER_FIELDS',
    UserFieldsWithMembersPlaceholder: 'USER_FIELDS_WITH_MEMBERS_PLACEHOLDER',
    SprintUsers: 'SPRINT_USERS'
};
export const AssigneePickerOptionGroupId = {
    Assignees: 'assignees',
    Users: 'users',
    Teams: 'teams',
    UsersNotInProject: 'users_not_in_project',
    TeamMembers: 'team_members',
    Roles: 'roles',
    OtherTeamMembers: 'other_team_members',
    Partners: 'partners',
    PlaceholderResolutions: 'placeholder_resolutions',
    UserFields: 'user_fields',
    UserFieldsWithMembersPlaceholder: 'user_fields_with_members_placeholder',
    SprintUsers: 'sprint_users',
    NonSprintUsers: 'non_sprint_users'
};
